module.exports = __webpack_public_path__ + "img/machine_2.a94342ff.jpg";